exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\r\n.wrap{\r\n    width:100%;\r\n    border: none;\r\n\r\n    \r\n}\r\n\r\n.buttonWrap {\r\n /* margin-top: -30;*/\r\n    float: right;\r\n    z-index: 1000;\r\n}", ""]);

